const ui = {
    id_main_group:"-1",
    groups:[],
    groupsUser:[],
    volumes:[],
    subgroup:[],
    subgroupUser:[],
    language:[],
    roles:[],
    openModalImportUsers:false,
    openModalSupport:false,
    openModalActiveVolumen:false,
    ModalImportUserSubGroup:false,
    ModalImportUserGroup:false,
    ModalImportSubgroup:false,
};
export default ui;